export { default } from "./VisitResults.gql";
